import { Box, Divider, Tab } from '@mui/material';
import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SolaForceTabs } from '~/components/SolaForceTabs';
import { AbsenceType } from '~/data/absences/types';
import { useSelectedEmployeeId } from '~/hooks/employee';
import { AbsencesTable } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/AbsencesTable';
import { PeopleModuleBasicDataAccessMode } from '~/scenes/PeopleModule/components/Tabs/BasicTab';

import { AbsenceCalendar } from './components/AbsenceCalendar';
import { VacationBalanceData } from './components/VacationBalanceData';
import { useSxStyles } from './useStyles';

type PropsType = {
  accessMode: PeopleModuleBasicDataAccessMode;
};

export const AbsencesTab = (props: PropsType) => {
  const { accessMode } = props;

  switch (accessMode) {
    case PeopleModuleBasicDataAccessMode.Full:
      return <AbsencesTabFullAccess />;
    default:
      return <>TBA Limited access absences</>;
  }
};

export const AbsencesTabFullAccess = () => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const { selectedEmployeeId } = useSelectedEmployeeId();

  const [selectedTab, setSelectedTab] = useState<AbsenceType>(
    AbsenceType.SHORT,
  );
  const getTabLabel = (tab: string) => {
    switch (tab) {
      case AbsenceType.LONG:
        return t('laLongTermAbsences');
      case AbsenceType.SHORT:
        return t('laShortTermAbsences');
      default:
        return '';
    }
  };

  return (
    <>
      <SolaForceTabs
        value={Object.keys(AbsenceType).indexOf(selectedTab)}
        onChange={(_event, value) => {
          const tab = Object.keys(AbsenceType)[value];

          if (!!tab) {
            setSelectedTab(tab as AbsenceType);
          }
        }}
        background={'fade'}
        sx={sxStyles.tabsOffset}
      >
        {Object.keys(AbsenceType).map((type, index) => (
          <Tab key={index} label={getTabLabel(type)} data-cy={type} />
        ))}
      </SolaForceTabs>

      <Box sx={sxStyles.contentTabs}>
        {selectedTab === AbsenceType.SHORT && (
          <Box sx={sxStyles.activeContent}>
            <VacationBalanceData />
            <Divider sx={sxStyles.sfHR} />
            <AbsencesTable
              absenceType={AbsenceType.SHORT}
              employeeId={selectedEmployeeId}
            />
            <Divider sx={sxStyles.sfHR} />
            <AbsenceCalendar />
          </Box>
        )}
        {selectedTab === AbsenceType.LONG && (
          <Box sx={sxStyles.activeContent}>
            <AbsencesTable
              absenceType={AbsenceType.LONG}
              employeeId={selectedEmployeeId}
            />
            <Divider sx={sxStyles.sfHR} />
            <AbsenceCalendar />
          </Box>
        )}
      </Box>
    </>
  );
};
